export default {
    data() {
        return {
            truckHeaders: [
                {
                    text: 'IMM.Number',
                    value: 'immatriculationNumber',
                    type: 'textfield'
                },
                {
                    text: 'Truck Identifier',
                    value: 'truckIdentifier',
                    type: 'textfield'
                },
                {
                    text: 'Horse Power',
                    value: 'horsePower',
                    type: 'textfield'
                },
                {
                    text: 'Fuel Consumption (km / 20L)',
                    value: 'fuelConsumptionKPL',
                    type: 'textfield'
                },
                {
                    text: 'Capacity m3',
                    value: 'cubicCapacity',
                    type: 'textfield'
                },
                {
                    text:'Assigned Clients',
                    value:'deliveryAddresses',
                    type:'multiselect',
                    entity:'deliveryAddress',
                    selector:'name',
                    multiple:true,
                    chipColor:"blue",
                    hide_client:true
                    },
            ]
        }
    }
}